export default "__VITE_ASSET__B9J_v7Js__"